import { ISal } from './../interfaces/ISal';
import { AlertUtil } from './../utils/alert-util';
import { Component, OnInit } from '@angular/core';
import { ICommessa } from '../interfaces/ICommessa';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as Moment from 'moment'
import { Loading } from '../utils/loading';
import { RequestBuilder } from '../classes/request-builder';
import { CommessaService } from '../services/commessa.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-sal-for-commessa-modal',
  templateUrl: './sal-for-commessa-modal.component.html',
  styleUrls: ['./sal-for-commessa-modal.component.css']
})
export class SalForCommessaModalComponent implements OnInit {

  listCommesse: ICommessa[]          //list of commesse
  it: any                            //lingua del calendario
  newSALform: FormGroup              //SAL form
  avanzamentoAttuale: number = 0     //percentage of avanzamento SAL commessa
  avanzamentoNew: number             //percentage of new avanzamento
  commessaSelected: ICommessa = null //commessa selected
  disabled: boolean = true;
  L = Loading
  datiCommessa: ICommessa
  currentSAL: ISal                    //sal for update
  isNewSAL: boolean                   //determines whether modal was opend for new SAL

  uploadedFiles: any[] = [];          //for upload file
  nameAllegato: string = null         //name allegato

  constructor(private config: DynamicDialogConfig,
    private formBuilder: FormBuilder,
    private commessaService: CommessaService,
    private alertUtil: AlertUtil,
    public ref: DynamicDialogRef) {
      
    this.listCommesse = this.config.data.listCommesse
    this.currentSAL = this.config.data.sal

    this.isNewSAL = !this.currentSAL  //currentSAL undefined means this is a new SAL

    // set commessa select if SAL must be updated
    if (!this.isNewSAL) {
      this.commessaSelected = this.listCommesse[0]  //if update mode set commessaSelected as first element in the list (the only commessa in the list and disable select)
      this.nameAllegato = this.currentSAL.NomeAllegato
    }

    //build form group
    this.newSALform = this.formBuilder.group({
      'commessa': [{ value: !this.isNewSAL ? this.commessaSelected : '', disabled: !this.isNewSAL ? true : false }, Validators.required], // if update mode select commessaSelected
      //'avanzamento': [{value:'',disabled: true }, Validators.compose([Validators.required, Validators.min(this.avanzamentoAttuale + 1), Validators.max(100), Validators.minLength(3)])],
      'avanzamento': [{ value: !this.isNewSAL ? this.currentSAL.Avanzamento_percentuale : '', disabled: true }, Validators.required],
      'dataSAL': [{ value: !this.isNewSAL ? this.formatDateForCalendar(this.currentSAL.Data) : '', disabled: true }, Validators.required],
      'note': [{ value: !this.isNewSAL ? this.currentSAL.Note : '', disabled: true }]
    });

    // enable form fields if this SAL must be updated
    if (!this.isNewSAL) {
      this.enabledFormField()
    }
  }

  ngOnInit() {
    this.setLanguageForCalendar()
  }

  // convenience getter for easy access to form fields
  get form() { return this.newSALform.controls }


  /**
   * drop down commesse event
   * @param event 
   */
  onCommessaSelected(event: any) {
    this.commessaSelected = event.value
    this.disabled = false
    //this.callCommessaFetchSingle()
    this.enabledFormField();
  }

  /**
   * enable form field after call service
   */
  enabledFormField() {
    this.newSALform.controls['avanzamento'].enable();
    this.newSALform.controls['dataSAL'].enable();
    this.newSALform.controls['note'].enable();
  }

  /**
   * language for calendar
   */
  setLanguageForCalendar() {
    /**
    * Lingua italiana nel calendario
    */
    this.it = {
      firstDayOfWeek: 1,
      dayNames: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
      dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
      dayNamesMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
      monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
      monthNamesShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
      today: 'Oggi',
      clear: 'Cancella'
    };
  }

  onSubmit() {
    if (this.newSALform.valid) {
      //retrieve values from form
      let avanzamento = this.newSALform.controls['avanzamento'].value
      let data = this.newSALform.controls['dataSAL'].value
      let note = this.newSALform.controls['note'].value

      this.setObjCommessaNull();

      if (this.isNewSAL) {
        //insert new SAL
        let SALCommessa: ISal = {
          Avanzamento_percentuale: avanzamento,
          Data: this.formatDateForSave(data),
          Note: note,
          Commessa: this.commessaSelected
        }

        this.callSaveSal(SALCommessa);
      }
      else {
        //update existing SAL
        this.currentSAL.Avanzamento_percentuale = avanzamento
        this.currentSAL.Data = this.formatDateForSave(data)
        this.currentSAL.Note = note

        this.callSaveSal(this.currentSAL)
      }
    }
  }

  /**
   * set null all object for commessa
   */
  private setObjCommessaNull() {
    this.commessaSelected.Cantieri = null;
    this.commessaSelected.Aggiudicatario = null;
    this.commessaSelected.Richieste = null;
    this.commessaSelected.Attivita = null;
  }

  /**
  * format date to YYYY-MM-DDTHH:mm:ss from DD/MM/YYYY
  * @param dateValue item value
  */
  formatDateForSave(dateValue: Date): string {
    return Moment(dateValue).format("YYYY-MM-DDTHH:mm:ss")
  }

  /**
   * format date from YYYY-MM-DDTHH:mm:ss to DD/MM/YYYY
   * @param dateValue 
   */
  formatDateForCalendar(dateValue: string): Date {
    return new Date(dateValue)
  }

  /**
   * disabled input
   */
  isDisabledInput(): boolean {
    return this.commessaSelected == null ? true : false
  }

  /**
   * call commessa fetch single
   */
  callCommessaFetchSingle() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({ Id: this.commessaSelected.Id }, ["SAL"])
    this.commessaService.getCommessaData(reqBuilder).subscribe(
      response => {
        Loading.isLoading = false
        if (response.data) {
          this.datiCommessa = response.data
          /*if (this.datiCommessa.SAL) {
            this.calculateMaxOfArray()
            this.avanzamentoNew = this.avanzamentoAttuale + 1
          }*/
        } else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        } else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        Loading.isLoading = false
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }


  /**
   * calculate max of array and set avanzamento attuale
   */
  calculateMaxOfArray() {
    let avanzamentoArray: number[] = [];
    this.datiCommessa.SAL.forEach(itemSAL => {
      avanzamentoArray.push(itemSAL.Avanzamento_percentuale);
    });

    this.avanzamentoAttuale = avanzamentoArray.length > 0 ? this.getMaxOfArray(avanzamentoArray) : 0

  }

  /**
   * return max value of number array
   * @param numArray 
   */
  getMaxOfArray(numArray: number[]): number {
    return Math.max.apply(null, numArray);
  }

  /**
   * save SAL data
   */
  callSaveSal(SALCommessa: ISal) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(SALCommessa, ["Commessa"])
    this.commessaService.saveSALofCommessa(reqBuilder).subscribe(response => {
      Loading.isLoading = false
      if (response.data) {
        if (this.uploadedFiles && this.uploadedFiles.length > 0) {
          let salSaved: ISal = response.data
          this.callSaveAllegato(salSaved)
        } else {
          this.saveSuccesMessage(response.data)
        }
      } else if (response.error) {
        let errorKey = "LBL_ERROR_" + response.error.Code
        this.alertUtil.showErrorAlert(errorKey)
        console.log("ERROR: " + response.error.Stack)
      } else {
        this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
      }
    },
      error => {
        Loading.isLoading = false
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * click button allega doc
   * @param event file
   * @param question question selected
   */
  uploadClick(event: any, upload: any) {
    this.uploadedFiles = []
    upload.clear()
    for (let file of event.files) {
      this.uploadedFiles.push(file);
    }
    this.nameAllegato = this.uploadedFiles[0].name
  }

  /**
   * save success
   */
  saveSuccesMessage(salSaved: ISal) {
    this.alertUtil.showAlert("LBL_SAL_SAVE_SUCCESS", null, null, null, () => {
      this.ref.close(salSaved);
    });
  }

  /**
   * call service for save allegato
   */
  callSaveAllegato(salSaved: ISal) {
    Loading.isLoading = true
    this.commessaService.uploadAllegatoSAL(this.uploadedFiles[0], this.uploadedFiles[0].name, salSaved.Id.toString()).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) { //return all allegatoObj
          this.saveSuccesMessage(salSaved);
        } else {
          this.alertUtil.showErrorAlert("LBL_ERROR_300")
        }
      })
  }
}
